export default [
  {
    path: 'reembolsos',
    name: 'refunds',
    component: () => import(/* webpackChunkName: "refunds" */ './Index.vue'),
    meta: {
      title: 'Reembolsos',
      icon: 'mdi-currency-usd-circle',
      admin: true
    }
  },
  {
    path: 'reembolsos/:id',
    name: 'refunds.view',
    component: () => import(/* webpackChunkName: "refunds" */ './View.vue'),
    meta: {
      title: 'Reembolso',
      icon: 'mdi-currency-usd-circle',
      admin: true
    }
  }
];
